import { useDispatch, useSelector } from 'react-redux';
import { useUpdateLanguageCodeMutation } from 'lib/services/languages';
import { selectCurrentLanguage, setLanguage } from 'lib/slices';
import useLocalStorage from 'utils/hooks/useLocalStorage';
import { useEffect, useCallback } from 'react';

const useUpdateLanguage = (): [
    string,
    (e: any, value: string) => Promise<void>,
] => {
    const dispatch = useDispatch();
    const language = useSelector(selectCurrentLanguage);
    const [updateLanguageCode] = useUpdateLanguageCodeMutation();
    const [storedValue, setLangInStorage] = useLocalStorage<string | null>(
        'languageCode',
        null,
    );

    useEffect(() => {
        const initialLang = storedValue || 'eng';
        dispatch(setLanguage(initialLang));
        updateLanguageCode({ languageCode: initialLang })
            .unwrap()
            .catch(() => {});
    }, [storedValue, updateLanguageCode, dispatch]);

    const onLanguageChange = useCallback(
        async (_: any, value: string) => {
            setLangInStorage(value);
            dispatch(setLanguage(value));
            try {
                await updateLanguageCode({ languageCode: value }).unwrap();
            } catch (error) {}
        },
        [dispatch, setLangInStorage, updateLanguageCode],
    );

    return [language, onLanguageChange];
};

export default useUpdateLanguage;
